import { ReactComponent as TimeIcon } from '@svgs/alarm.svg';
import { ReactComponent as AttitudeIcon } from '@svgs/attitude.svg';
import { ReactComponent as MaterialIcon } from '@svgs/book.svg';
import { ReactComponent as PeoplePassedIcon } from '@svgs/checkbox-done.svg';
import { ReactComponent as TestIcon } from '@svgs/document.svg';

export const tagLayoutByVariant = {
  attitude: {
    svg: AttitudeIcon,
  },
  knowledge: {
    svg: MaterialIcon,
  },
  material: {
    svg: MaterialIcon,
  },
  peoplePassed: {
    svg: PeoplePassedIcon,
  },
  test: {
    svg: TestIcon,
  },
  time: {
    svg: TimeIcon,
  },
};
